module.exports = __webpack_public_path__ + "img/icon_pending@2x.98672a9d.png";